// extracted by css-extract-rspack-plugin
export default {"searchInput":"searchInput-nRAl0U","list":"list-sF5yl6","listItem":"listItem-_esN7p"};